/**
 * Resout les entrees d'une composition (Match.lineup) en objets joueurs
 * complets, en fusionnant avec la liste des Players du club.
 *
 * Match.lineup ne contient que { player_id, name, number, position, starter }
 * (JSON dense persiste). La modale d'envoi des cartes a besoin de `email` et
 * `photo_url`, absents de la lineup -> on enrichit depuis les Players complets.
 *
 * @param {Array}  lineupEntries  sortie de extractLineup(match) (entrees lineup)
 * @param {Map}    playersById    Map<player_id, Player> (Players complets du club)
 * @returns {Array} [{ id, name, position, number, email, photo_url }]
 */
export function resolveLineupPlayers(lineupEntries, playersById) {
  if (!Array.isArray(lineupEntries)) return []
  return lineupEntries
    .map((entry) => {
      const pid = entry.player_id || entry.id
      if (!pid) return null
      const full = playersById.get(pid) || {}
      return {
        id: pid,
        name: full.name || entry.name || 'Joueur',
        position: entry.position || full.position || null,
        number: entry.number != null ? entry.number : (full.number ?? null),
        email: full.email || null,
        phone: full.phone || null,
        photo_url: full.photo_url || null,
      }
    })
    .filter(Boolean)
}
